import { render, staticRenderFns } from "./ListFormats.vue?vue&type=template&id=0ad7cbec"
import script from "./ListFormats.vue?vue&type=script&lang=js"
export * from "./ListFormats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports